let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("dnUsn"), load("1Cujm"), load("bVl1P")]).then(() => parcelRequire('hnY2b'));